var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mainDiv" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          model: {
            value: _vm.showInfoDialog,
            callback: function($$v) {
              _vm.showInfoDialog = $$v
            },
            expression: "showInfoDialog"
          }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "font-size": "17px",
                    "margin-left": "10px !important"
                  }
                },
                [_vm._v("Filtros Informe " + _vm._s(_vm.infoTypeReport))]
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card",
            { attrs: { "max-height": "300", id: "bodyDialogInfo" } },
            [
              _c(
                "div",
                {
                  staticStyle: { "margin-left": "20px", "margin-top": "20px" }
                },
                _vm._l(_vm.infoItems, function(item) {
                  return _c(
                    "div",
                    { key: item.index, staticClass: "itemInfoDiv" },
                    [
                      _c("li", [
                        _c(
                          "strong",
                          { staticStyle: { "margin-right": "7px" } },
                          [_vm._v(_vm._s(item.key) + ": ")]
                        ),
                        _vm._v(
                          "\n            " + _vm._s(item.value) + "\n          "
                        )
                      ])
                    ]
                  )
                }),
                0
              )
            ]
          )
        ],
        1
      ),
      _c("div", { attrs: { id: "headerDiv" } }, [
        _c(
          "div",
          { staticStyle: { width: "50%" } },
          [
            _c("v-text-field", {
              staticStyle: { width: "70%" },
              attrs: {
                label: "Buscar...",
                "single-line": "",
                "hide-details": ""
              },
              on: { input: _vm.handleSearch },
              model: {
                value: _vm.searchReport,
                callback: function($$v) {
                  _vm.searchReport = $$v
                },
                expression: "searchReport"
              }
            })
          ],
          1
        ),
        _c(
          "fieldset",
          {
            staticStyle: {
              margin: "1.5em",
              display: "flex",
              height: "95%",
              border: "1px solid #dcdcdc",
              "margin-left": "auto"
            }
          },
          [
            _c(
              "legend",
              {
                staticStyle: {
                  "margin-left": "0.3rem",
                  color: "#9e9e9e",
                  "font-size": "0.8rem"
                }
              },
              [_vm._v("\n        Búsqueda por Fecha Generación\n      ")]
            ),
            _c(
              "span",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "flex-end"
                }
              },
              [
                _c(
                  "div",
                  { staticStyle: { margin: "20px" } },
                  [
                    _c("DatePicker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        label: _vm.formsFields.fechaDesde.label,
                        "error-messages": _vm.errors.collect(
                          _vm.formsFields.fechaDesde.id
                        ),
                        id: _vm.formsFields.fechaDesde.id,
                        min: _vm.fechaMinima,
                        max: _vm.fechaMaxima
                      },
                      on: { input: _vm.validateDates },
                      model: {
                        value: _vm.formsFields.fechaDesde.value,
                        callback: function($$v) {
                          _vm.$set(_vm.formsFields.fechaDesde, "value", $$v)
                        },
                        expression: "formsFields.fechaDesde.value"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { margin: "20px" } },
                  [
                    _c("DatePicker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        label: _vm.formsFields.fechaHasta.label,
                        "error-messages": _vm.errors.collect(
                          _vm.formsFields.fechaHasta.id
                        ),
                        id: _vm.formsFields.fechaHasta.id,
                        min: _vm.fechaMinima,
                        max: _vm.fechaMaxima
                      },
                      on: { input: _vm.validateDates },
                      model: {
                        value: _vm.formsFields.fechaHasta.value,
                        callback: function($$v) {
                          _vm.$set(_vm.formsFields.fechaHasta, "value", $$v)
                        },
                        expression: "formsFields.fechaHasta.value"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: { disabled: _vm.datesHasChange, color: "#FFE700" },
                    on: { click: _vm.intervalSearchReports }
                  },
                  [_vm._v("Buscar")]
                )
              ],
              1
            )
          ]
        )
      ]),
      _c("div", { attrs: { id: "bodyDiv" } }, [
        _c("div", { staticStyle: { height: "100%", width: "100%" } }, [
          _c(
            "div",
            { staticClass: "gridcard rounded-card" },
            [
              _c("ag-grid-vue", {
                staticClass: "ag-theme-material",
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  "font-family": "'Asap', sans-serif"
                },
                attrs: { gridOptions: _vm.gridOptions }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }